import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../app/store/configureStore";
import { entrezDbSelectors } from "../../app/store/entrezDbSlice";
import { entrezConfig } from "../../app/util/entrezConfig";

export default function PageSizeSelection(props: {onPageSizeSelection: (arg0: number) => void;})
  
 {
  const { dbParams } = useAppSelector((state) => state.entrezDb);
  
  const selectedDBWithAllState = useAppSelector((state) =>
    entrezDbSelectors.selectById(state, dbParams.db)
  );

  const [pageSize, setPageSize] = useState(selectedDBWithAllState!.paginationData.pageSize);

  useEffect(() => {
    console.log("useEffect - PageSizeSelection: " + selectedDBWithAllState!.paginationData.pageSize);
    setPageSize(selectedDBWithAllState!.paginationData.pageSize);
  }, [selectedDBWithAllState!.paginationData.pageSize]);

  const numbers: number[] = entrezConfig.PagesSizeOptions;

  const handleChange = (event: SelectChangeEvent) => {
    setPageSize(parseInt(event.target.value));
    console.log("updated paze size is");
    console.log(event.target.value);
    props.onPageSizeSelection(+event.target.value);
  };

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <FormControl sx={{ minWidth: 50 }}>
        {/* <InputLabel variant="standard" htmlFor="uncontrolled-native">
          Items per page
        </InputLabel> */}
        <Select
          sx={{ height: 25 }}
          value={pageSize.toString()}
          inputProps={{ "aria-label": "Without label" }}
          onChange={handleChange}
          displayEmpty
        >
          {numbers.map((num) => (
            <MenuItem key={num} value={num}>
              {num}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>

    //  <Container>
    // <Box display="flex" justifyContent="space-between"  alignItems="left">
    //   <FormControl required sx={{  minWidth: 100 }}>
    //     <InputLabel id="size-required-label">Items per page</InputLabel>
    //     <Select
    //       labelId="size-required-label"
    //       id="size-required-label"
    //       value={pageSize.toString()}
    //       label="Items per page"
    //       onChange={handleChange}
    //     >
    //       {/* <MenuItem value="">   <em>None</em>  </MenuItem> */}
    //       {numbers.map((num) => (
    //         <MenuItem key={num} value={num}>
    //           {num}
    //         </MenuItem>
    //       ))}
    //     </Select>
    //     {/* <FormHelperText>Required</FormHelperText> */}
    //   </FormControl>
    // </Box>
    //  </Container>
  );
}
